import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abs'
})
export class AbsPipe implements PipeTransform {
  /**
   *
   * @param value
   * @param args
   */
  transform(value: any, args?: any[]): number | any {
    if (value) {
      switch (typeof value) {
        case 'number':
          return Math.abs(value);
          break;
        default :
          return value;
          break;
      }
    }
  }
}
